import { Component, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import {
  TrackingPageProductCard,
  TrackingPageProductsFeedItem
} from '../../tracking-page.model';

@Component({
  selector: 'app-tracking-page-products-feed-item',
  templateUrl: './tracking-page-products-feed-item.component.html',
  styleUrls: ['./tracking-page-products-feed-item.component.scss']
})
export class TrackingPageProductsFeedItemComponent {
  @Input() productItem: TrackingPageProductsFeedItem;
  @Input() itemStyles: TrackingPageProductCard;
  @Input() placement: string;
  @Input() selectedId: any;
  @Input() isVisualBuilder = true;
  @Output() selectBlock = new EventEmitter();

  public readonly imageUrl = environment.assetsUrl;

  get regularPriceStyles() {
    const { fontSize, font } =
      this.productItem?.discountedPrice?.length > 0
        ? this.itemStyles.regularPrice
        : this.itemStyles.discountedPrice;
    return {
      'fontSize.px': fontSize,
      textDecoration:
        this.productItem?.discountedPrice?.length > 0 ? 'line-through' : 'none',
      'marginRight.px': this.productItem?.discountedPrice?.length > 0 ? 5 : 0,
      'lineHeight.px': fontSize * 1.21,
      color: font.fontColor
    };
  }

  get buttonStyles() {
    const { borderRadius, borderWidth, borderColor, backgroundColor, shadow } =
      this.itemStyles.button;
    return {
      'width.%': 100,
      'borderRadius.px': borderRadius,
      'borderWidth.px': borderWidth,
      borderColor,
      backgroundColor,
      boxShadow: shadow
    };
  }

  selectItem(
    { target },
    button,
    buttonText,
    title,
    price,
    titleSpan,
    priceSpan1,
    priceSpan2
  ) {
    if (this.isVisualBuilder) {
      this.selectBlock.emit({
        target,
        button,
        buttonText,
        title,
        price,
        titleSpan,
        priceSpan1,
        priceSpan2
      });
    }
  }

  onAnchorClick(event) {
    if (this.isVisualBuilder) {
      event.preventDefault();
    }
  }
}
